export default __webpack_public_path__ + "static/media/Iconly-Bold-Swap.9e9daba8.svg";